import NavDesktopParent from './NavDesktopParent';

export default class NavDesktopMenu {
  constructor(el) {
    this.parents = [];

    const { children } = el;

    const closeSiblings = (current) => {
      this.parents.forEach((parent) => {
        if (parent !== current) {
          parent.close();
        }
      });
    };

    for (let i = 0; i < children.length; i++) {
      if (children[i].dataset.navmenuParent !== undefined) {
        this.parents.push(
          new NavDesktopParent(
            children[i],
            {
              closeSiblings,
            },
          ),
        );
      } else if (children[i].classList.contains('navmenu-item')) {
        children[i].addEventListener('focusin', closeSiblings);
      }
    }
  }

  unload() {
    this.parents.forEach((parent) => { parent.unload(); });
  }
}
